/** @return {import("electron") & {remote:import('@electron/remote')}} */
const getElectron = () => window.nodeModules?.electron;

export default getElectron;
